<template>
  <div class="mod-article-inner">
    <preview-job-content-header
      v-if="title"
      :title="title"
    >
      <slot />
    </preview-job-content-header>
    <p
      class="pega-pre-wrap"
      data-test="text"
      v-html="text"
    />
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
import PreviewJobContentHeader from '@/components/atoms/PreviewJobContentHeader'

export default {
  components: {
    PreviewJobContentHeader
  },
  props: {
    text: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
